<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-dialog v-model="showSchema" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="showSchema = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Схема зала</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="updateTables()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
         <div class="d-flex justify-center">
           <canvas id="schema" class="schema" width="500" height="500" style="z-index: 1;"></canvas>
         </div>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center" v-if="reservation">
      <v-col
        cols="12"
        md="6"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Инофрмация о клиенте
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <h1>{{reservation.guest.first_name || '' }} {{reservation.guest.last_name || '' }}</h1>
                </v-col>


                <v-col cols="6">
                  Телефон : <h4>{{reservation.guest.phone }}</h4>
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                >
                  Примечания : <h4>{{reservation.guest.notes }}</h4>
                </v-col>

                <v-col
                  cols="6"
                  md="6"
                >
                  Email : <h4>{{reservation.guest.email }}</h4>
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                >
                  Дата создания : <h4>{{reservation.guest.created_at }}</h4>
                </v-col>


              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">

          </div>
        </base-material-card>
        <base-material-card
          color="info"
          icon="mdi-twitter"
          title="Изменить статус">
          <v-row class="d-flex justify-lg-space-between p-0 m-0">
            <v-col
              cols="12"
              md="6"
            >
              <v-select v-model="status" :items="statuses" label="Статус" item-text="name" item-value="id">
                <template v-slot:item="{ item }">
                  <v-chip
                    style="color: white"
                    class="ma-2"
                    :color="item.color"
                  >
                    {{ item.name }}
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="6"
              md="6"
            >
              <v-textarea
                name="input-7-1"
                filled
                height="15px"
                v-model="comment"
                label="Комментарий"
                auto-grow
                value=""
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-lg-space-between p-0 m-0">
            <v-col
              cols="6"
              md="6 "
            >

              <v-checkbox
                v-model="sendSms"
                label="Отправить смс гостю"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="6"
              md="6"
            >
              <v-textarea v-if="sendSms"
                          name="input-7-1"
                          filled
                          v-model="textSms"
                          height="15px"
                          label="Текст смс"
                          auto-grow
                          value=""
              ></v-textarea>
              <div class="my-2 d-flex justify-end">
                <v-btn small color="primary" dark @click="saveStatus" :loading="savingStatus">Сохранить</v-btn>
              </div>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Информация о брони
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  Ресторан :
                  <v-chip
                    style="color: white"
                    class="ma-2"
                    color="error"
                  >
                    {{ reservation.restaurant.title }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  Зона :
                  <v-chip v-if="getTitleZone(reservation.tables[0])"
                          style="color: white"
                          class="ma-2"
                          color="green"
                  >
                    {{getTitleZone(reservation.tables[0])}}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  Столы :
                  <v-chip v-for="table in reservation.tables" :id="reservation.id"
                          class="ma-2"
                          color="deep-purple lighten-4"
                  >
                    {{table.table.number}}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  Статус :
                  <v-chip
                    style="color: white"
                    class="ma-2"
                    :color="reservation.status.color"
                  >
                    {{ reservation.status.name }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  Кол-во гостей : {{ reservation.count_person }}
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  Время визита : {{ reservation.date_time_visit }}
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  Дата создания : {{ reservation.created_at }}
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <strong>Примечания</strong> : {{ reservation.notes }}
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">

          </div>
        </base-material-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              История
            </div>
          </template>

          <v-data-table
            :headers="headers"
            :items="reservation.history"
            disable-sort
            disable-filtering
            disable-pagination
            hide-default-footer
            class="elevation-1"
          >

            <template v-slot:item.createdAt="{ item }">
              {{ item.created_at }}
            </template>


            <template v-slot:item.status="{ item }">
              <v-chip
                style="color: white"
                class="ma-2"
                :color="item.status.color"
              >
                {{ item.status.name }}
              </v-chip>
            </template>

            <template v-slot:item.comment="{ item }">
              {{item.comment}}
            </template>
            <template v-slot:item.initiator="{ item }">
              {{item.user.first_name}} {{item.user.last_name}}
            </template>
          </v-data-table>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  const API_URL_SAVE_STATUS = 'reservation/:restaurantId/:reservationId/set-status';
  import FreeTable from "./mixin/FreeTable";
  import ReservationHelper from "./mixin/ReservationHelper";

  export default {
    props: {
      restaurantId: {
        type: [String, Number]
      },
      id: {
        type: [String, Number]
      }
    },
    mixins: [FreeTable, ReservationHelper],
    methods: {
      updateTables() {

        axios.post('reservation/' + this.restaurantId + '/' + this.id, {
          tables : this.selectionTables
        }).then(() => {
          this.showSchema = false;
          this.loadReservation();
        })
      },
      loadReservation() {
        axios.get('reservation/' + this.restaurantId + '/' + this.id)
          .then(({data}) => {
            this.reservation = data.data;
            this.status = this.reservation.status.id;
            this.restaurant = this.reservation.restaurant

            var tables = [];
            this.reservation.tables.map((item) => {
              tables.push(parseInt(item.table.id))
            });
            this.selectionTables = tables;

          });
      },
      saveStatus() {
        if (this.savingStatus) {
          return
        }
        this.savingStatus = true;

        let data = {
          status: this.status,
          comment: this.comment,
          sendSms: this.sendSms,
          textSms: this.textSms || ''
        };

        let url = API_URL_SAVE_STATUS
          .replace(':restaurantId', this.restaurantId)
          .replace(':reservationId', this.id);

        axios.post(url, data)
          .then((data) => {
            this.loadReservation()
            this.savingStatus = false;
          })
          .catch(e => {
            this.savingStatus = false;
          })
        this.savingStatus = false;
      },
      getTitleZone(table) {
        try {
          return table.zone.title
        } catch (e) {
          return ''
        }
      }
    },
    mounted() {
      axios.get('list-status')
        .then(({data}) => {
          this.statuses = data.data
        })
      this.loadReservation()
    },
    computed: {
      reservationInfo() {
        return {
          dateVisit: this.reservation.date_visit,
          timeVisit: this.reservation.time_visit,
          duration: this.reservation.duration,
          exclude: this.id
        }
      }
    },
    watch: {
      showSchema() {
        if (this.showSchema) {
          this.getFreeTables()
          setTimeout(() => {
            if(!this.canvas){
              this.initCanvas();
            }

          }, 200)
        }
      }
    },
    data() {
      return {
        restaurant: null,
        showSchema: false,
        savingStatus: false,
        sendSms: false,
        status: null,
        comment: null,
        textSms: null,
        statuses: [],
        reservation: {},
        headers: [
          {
            text: 'Дата ',
            align: 'start',
            sortable: false,
            value: 'createdAt',
          },
          {
            text: 'Статус ',
            align: 'start',
            sortable: false,
            value: 'status',
          },
          {
            text: 'Комментарий ',
            align: 'start',
            sortable: false,
            value: 'comment',
          },
          {
            text: 'Инициатор ',
            align: 'start',
            sortable: false,
            value: 'initiator',
          }
        ],
      }
    }
  }
</script>

<style scoped>

</style>
